import { LoginConnectorApollo, UserDataConnectorApollo } from '@front-activerse/common-components';
import AuthLoginByEmailAndPasswordForm from '../../Auth/Login/AuthLoginByEmailAndPasswordForm';

interface IActiveProductLoginContainer {
  pathActiveProduct: string;
}

const ActiveProductLoginContainer: React.FC<IActiveProductLoginContainer> = ({
  pathActiveProduct,
}) => {
  return (
    <LoginConnectorApollo>
      {({ ...login }) => (
        <UserDataConnectorApollo>
          {({ ...userDataOnDemand }) => (
            <AuthLoginByEmailAndPasswordForm
              {...login}
              {...userDataOnDemand}
              userDataOnDemand={userDataOnDemand.userDataOnDemand}
              redirectToPathAfterSuccess={pathActiveProduct}
            />
          )}
        </UserDataConnectorApollo>
      )}
    </LoginConnectorApollo>
  );
};

export default ActiveProductLoginContainer;
